/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Swal_ConfirmInputs */

const en_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_paste_swal_confirm = /** @type {(inputs: Paste_Swal_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Paste_Swal_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_swal_confirm = /** @type {((inputs?: Paste_Swal_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Swal_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_swal_confirm(inputs)
	if (locale === "de") return de_paste_swal_confirm(inputs)
	if (locale === "it") return it_paste_swal_confirm(inputs)
	if (locale === "ru") return ru_paste_swal_confirm(inputs)
	if (locale === "es") return es_paste_swal_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_swal_confirm(inputs)
	if (locale === "ja") return ja_paste_swal_confirm(inputs)
	if (locale === "hi") return hi_paste_swal_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_swal_confirm(inputs)
	return en_paste_swal_confirm(inputs)
});